var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeRed({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6520_25825)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.00016 2.33334C4.0835 2.33334 1.59266 4.14751 0.583496 6.70834C1.59266 9.26918 4.0835 11.0833 7.00016 11.0833C9.91683 11.0833 12.4077 9.26918 13.4168 6.70834C12.4077 4.14751 9.91683 2.33334 7.00016 2.33334ZM7.00016 9.62501C5.39016 9.62501 4.0835 8.31834 4.0835 6.70834C4.0835 5.09834 5.39016 3.79168 7.00016 3.79168C8.61016 3.79168 9.91683 5.09834 9.91683 6.70834C9.91683 8.31834 8.61016 9.62501 7.00016 9.62501ZM7.00016 4.95834C6.03183 4.95834 5.25016 5.74001 5.25016 6.70834C5.25016 7.67668 6.03183 8.45834 7.00016 8.45834C7.9685 8.45834 8.75016 7.67668 8.75016 6.70834C8.75016 5.74001 7.9685 4.95834 7.00016 4.95834Z",
    fill: "#FF4D4F",
    fillOpacity: 0.45
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6520_25825"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeRed);
export default __webpack_public_path__ + "static/media/eye-red.4f24db3297c1cff89e0ffd45f275bc10.svg";
export { ForwardRef as ReactComponent };